<template>
<form @submit.prevent="onsubmit()">
  <va-input
    v-model="email"
    type="email"
    :label="$t('auth.email')"
    :error="!!emailErrors.length"
    :error-messages="emailErrors"
  />

  <va-input
    v-model="password"
    type="password"
    :label="$t('auth.password')"
    :error="!!passwordErrors.length"
    :error-messages="passwordErrors"
  />

  <div class="auth-layout__options d-flex align--center justify--space-between">
    <va-checkbox
      v-model="agreedToTerms"
      class="mb-0"
      :error="!!agreedToTermsErrors.length"
      :errorMessages="agreedToTermsErrors"
    >
      <template slot="label">
        {{ $t('auth.agree') }}
        <span class="link">{{ $t('auth.termsOfUse') }}</span>
      </template>
    </va-checkbox>
    <router-link class="ml-1 link" :to="{name: 'recover-password'}">
      {{$t('auth.recover_password')}}
    </router-link>
  </div>

  <div class="d-flex justify--center mt-3">
    <va-button type="submit" class="my-0">{{ $t('auth.sign_up') }}</va-button>
  </div>
</form>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/auth'
import userService from '../../../api/userService'

export default {
  name: 'signup',
  data () {
    return {
      email: '',
      password: '',
      agreedToTerms: false,
      emailErrors: [],
      passwordErrors: [],
      agreedToTermsErrors: [],
    }
  },
  methods: {
    async onsubmit () {
      this.emailErrors = this.email ? [] : ['Email is required']
      this.passwordErrors = this.password ? [] : ['Password is required']
      this.agreedToTermsErrors = this.agreedToTerms ? [] : ['You must agree to the terms of use to continue']
      if (!this.formReady) {
        return
      }
      try {
        var authentication = await firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
        var user = authentication.user
        await user.sendEmailVerification()
        var fullName = await userService.get(user.email, user.emailVerified, user.uid)
        this.$router.replace({ name: 'open' })
      } catch (error) {
        this.showToast(error.message, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
    },
  },
  computed: {
    formReady () {
      return !(this.emailErrors.length || this.passwordErrors.length || this.agreedToTermsErrors.length)
    },
  },
}
</script>

<style lang="scss">
</style>
